/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
export const CpslAlert = /*@__PURE__*/ createReactComponent('cpsl-alert');
export const CpslAnimation = /*@__PURE__*/ createReactComponent('cpsl-animation');
export const CpslAppBar = /*@__PURE__*/ createReactComponent('cpsl-app-bar');
export const CpslAvatar = /*@__PURE__*/ createReactComponent('cpsl-avatar');
export const CpslButton = /*@__PURE__*/ createReactComponent('cpsl-button');
export const CpslButtonGroup = /*@__PURE__*/ createReactComponent('cpsl-button-group');
export const CpslCard = /*@__PURE__*/ createReactComponent('cpsl-card');
export const CpslCheckbox = /*@__PURE__*/ createReactComponent('cpsl-checkbox');
export const CpslCodeInput = /*@__PURE__*/ createReactComponent('cpsl-code-input');
export const CpslCol = /*@__PURE__*/ createReactComponent('cpsl-col');
export const CpslDivider = /*@__PURE__*/ createReactComponent('cpsl-divider');
export const CpslDrawer = /*@__PURE__*/ createReactComponent('cpsl-drawer');
export const CpslDropdown = /*@__PURE__*/ createReactComponent('cpsl-dropdown');
export const CpslFileUpload = /*@__PURE__*/ createReactComponent('cpsl-file-upload');
export const CpslGrid = /*@__PURE__*/ createReactComponent('cpsl-grid');
export const CpslHero = /*@__PURE__*/ createReactComponent('cpsl-hero');
export const CpslIcon = /*@__PURE__*/ createReactComponent('cpsl-icon');
export const CpslIdenticon = /*@__PURE__*/ createReactComponent('cpsl-identicon');
export const CpslInfoBox = /*@__PURE__*/ createReactComponent('cpsl-info-box');
export const CpslInput = /*@__PURE__*/ createReactComponent('cpsl-input');
export const CpslModal = /*@__PURE__*/ createReactComponent('cpsl-modal');
export const CpslModalV2 = /*@__PURE__*/ createReactComponent('cpsl-modal-v2');
export const CpslNavButtonGroup = /*@__PURE__*/ createReactComponent('cpsl-nav-button-group');
export const CpslOverlay = /*@__PURE__*/ createReactComponent('cpsl-overlay');
export const CpslPagination = /*@__PURE__*/ createReactComponent('cpsl-pagination');
export const CpslPill = /*@__PURE__*/ createReactComponent('cpsl-pill');
export const CpslPopover = /*@__PURE__*/ createReactComponent('cpsl-popover');
export const CpslProgressIndicator = /*@__PURE__*/ createReactComponent('cpsl-progress-indicator');
export const CpslQrCode = /*@__PURE__*/ createReactComponent('cpsl-qr-code');
export const CpslRadio = /*@__PURE__*/ createReactComponent('cpsl-radio');
export const CpslRow = /*@__PURE__*/ createReactComponent('cpsl-row');
export const CpslSelect = /*@__PURE__*/ createReactComponent('cpsl-select');
export const CpslSelectItem = /*@__PURE__*/ createReactComponent('cpsl-select-item');
export const CpslSlideButton = /*@__PURE__*/ createReactComponent('cpsl-slide-button');
export const CpslSpinner = /*@__PURE__*/ createReactComponent('cpsl-spinner');
export const CpslSwitch = /*@__PURE__*/ createReactComponent('cpsl-switch');
export const CpslTab = /*@__PURE__*/ createReactComponent('cpsl-tab');
export const CpslTable = /*@__PURE__*/ createReactComponent('cpsl-table');
export const CpslTabs = /*@__PURE__*/ createReactComponent('cpsl-tabs');
export const CpslText = /*@__PURE__*/ createReactComponent('cpsl-text');
export const CpslTileButton = /*@__PURE__*/ createReactComponent('cpsl-tile-button');
